import React from 'react';

type LinkButtonProps = {
  url?: string | null;
  onClick?: (event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void;
  icon?: JSX.Element;
  text: string;
  disabled?: boolean;
  underline?: boolean;
  iconPosition?: 'before' | 'after';
  className?: string;
  contentClassName?: string;
};

export const LinkButton: React.FC<LinkButtonProps> = ({
  url,
  onClick,
  icon,
  text,
  disabled = false,
  iconPosition = 'after',
  className = '',
  contentClassName = '',
  underline = true,
}) => {
  const content = (
    <span className={`flex items-center ${contentClassName}`}>
      {iconPosition === 'before' && <span className="pr-2">{icon}</span>}
      <span className={`leading-5 ${underline ? 'underline' : ''}`}>{text}</span>
      {iconPosition === 'after' && <span className="pl-2">{icon}</span>}
    </span>
  );

  return url ? (
    <a
      href={url}
      download
      target="_blank"
      className={`flex cursor-pointer items-center text-slate-200 transition-opacity duration-150 ${className} ${
        disabled ? 'cursor-not-allowed text-slate-400 opacity-30' : 'hover:opacity-75'
      }`}
      onClick={disabled ? undefined : onClick}
      rel="noreferrer"
    >
      {content}
    </a>
  ) : (
    <button
      type="button"
      className={`flex cursor-pointer items-center truncate text-pink-400 transition-opacity duration-150 ${className} ${
        disabled ? 'cursor-not-allowed text-slate-400 opacity-30' : 'hover:opacity-75'
      }`}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
    >
      {content}
    </button>
  );
};
